import { render, staticRenderFns } from "./SchoolInfoPage.vue?vue&type=template&id=0c82740b&scoped=true"
import script from "./SchoolInfoPage.vue?vue&type=script&lang=js"
export * from "./SchoolInfoPage.vue?vue&type=script&lang=js"
import style0 from "./SchoolInfoPage.vue?vue&type=style&index=0&id=0c82740b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c82740b",
  null
  
)

export default component.exports